import { get } from 'lodash';
import {
  createAPILifecycleActions,
  createAPILifecycleActionTypes,
} from '../../../../../../../redux/actions/action_utils';
import createAmplifyAPICallEpic from '../../../../../../../redux/epics/utils';
import { OVERRIDE_GROUPING_ENDPOINT } from '../../../../../../../common/config/api_endpoints';

export const OVERRIDE_CONTRACT_GROUPING_ACTION_TYPES = createAPILifecycleActionTypes(
  'OVERRIDE_CONTRACT_GROUPING_ACTION_TYPES',
);
export const overrideContractGroupingAction = createAPILifecycleActions(
  OVERRIDE_CONTRACT_GROUPING_ACTION_TYPES.NAME,
);

const initialState = {
  isFetching: false,
  data: null,
  error: null,
};
export default (state = initialState, { type, payload }) => {
  switch (type) {
    case OVERRIDE_CONTRACT_GROUPING_ACTION_TYPES.BEGIN:
      return {
        ...state,
        isFetching: true,
      };
    case OVERRIDE_CONTRACT_GROUPING_ACTION_TYPES.SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: {
          groupingId: get(payload, 'groupingId'),
          status: get(payload, 'status'),
        },
        error: null,
      };
    case OVERRIDE_CONTRACT_GROUPING_ACTION_TYPES.FAILURE:
      return {
        ...state,
        isFetching: false,
        data: null,
        error: payload,
      };

    case OVERRIDE_CONTRACT_GROUPING_ACTION_TYPES.CLEAR:
      return initialState;
    default:
      return state;
  }
};

export const overrideContractGroupingEpic = createAmplifyAPICallEpic({
  actionType: OVERRIDE_CONTRACT_GROUPING_ACTION_TYPES.BEGIN,
  api: OVERRIDE_GROUPING_ENDPOINT,
  successCallback: response => [overrideContractGroupingAction.SUCCESS(response)],
  errorCallback: () => [overrideContractGroupingAction.FAILURE()],
});
